import React from 'react';

import RequestDetailPage from './RequestDetailPage';
import { reserveFallbackDetails } from './requestQueueFallbacks';


export default function ReserveDetailPage() {
    return (
        <RequestDetailPage
            title="Резерв"
            backTo="/app/reserve"
            backLabel="Назад к резерву"
            mode="reserve"
            fallbackDetails={reserveFallbackDetails}
        />
    );
}
